import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'upsellTitle',
  initialState: '',
  reducers: {
    setUpsellTitle(state, action: PayloadAction<string>) {
      return action.payload;
    },
  },
});

export const { setUpsellTitle } = slice.actions;
export default slice.reducer;
